const state = {
  socket: null,  // 接続中のsocketを保持する
  socketState: 0,
  // 本番用
  url: 'wss://6wloa9rofk.execute-api.ap-northeast-1.amazonaws.com/Prod',
  // 開発用
  // url: 'wss://8866l0h7ja.execute-api.ap-northeast-1.amazonaws.com/Prod',
  // フロントテスト
  // url: 'ws://localhost:9999',
  isConnected: false
}
const actions = {
  setSocket({ commit }) {
    commit('setSocket')
  }
}
const mutations = {
  setSocket(state, payload) {
    // console.log("Starting Conection to WebSocket Server")
    state.socket = payload.socket
    state.isConnected = true
  },
  sendRequest(state, msg, socketState) {
    state.socketState = socketState
    state.socket.send(msg)
    console.log(msg)
    console.log(state.socketState)
  }
}

export default {
  state,
  actions,
  mutations
}
